module.exports = __webpack_public_path__ + "static/video_call-d7f00a900feaeb0cbfd79f2aac795836.png";